import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";

import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AppLayout from "@/layout/AppLayout";
import DashboardPage from "@/pages/DashboardPage";
import CasesListPage from "@/pages/CasesListPage";
import NewCasePage from "@/pages/NewCasePage";
import CaseDetailPage from "@/pages/CaseDetailPage";
import TemplatesPage from "@/pages/TemplatesPage";
import TemplateWizardPage from "@/pages/TemplateWizardPage";
import DraftEditorPage, { DraftsListPage } from "@/pages/DraftsPages";
import AgreementsPage from "@/pages/AgreementsPage";
import TasksPage from "@/pages/TasksPage";
import EducationPage from "@/pages/EducationPage";
import AIAssistantPage from "@/pages/AIAssistantPage";
import SettingsPage from "@/pages/SettingsPage";
import PublicSignPage from "@/pages/PublicSignPage";
import NyayaDrishtiPage from "@/pages/NyayaDrishtiPage";
import IncidentCapturePage from "@/pages/IncidentCapturePage";
import MattersListPage from "@/pages/MattersListPage";
import MatterDetailPage from "@/pages/MatterDetailPage";
import SignPage from "@/pages/SignPage";
import ComingSoonPage from "@/pages/ComingSoonPage";
import CaseFilingTemplatesPage from "@/pages/CaseFilingTemplatesPage";
import ClaimExplorerPage from "@/pages/ClaimExplorerPage";
import ObligationsPage from "@/pages/ObligationsPage";
import MarketplacePage from "@/pages/MarketplacePage";
import CompareAgreementsPage from "@/pages/CompareAgreementsPage";
import LearnPage from "@/pages/LearnPage";
import SignaturesPage from "@/pages/SignaturesPage";
import EnvelopeDetailPage from "@/pages/EnvelopeDetailPage";
import EnvelopeSignPage from "@/pages/EnvelopeSignPage";
import CaseStartersPage, { CaseStarterWizardPage } from "@/pages/CaseStartersPage";
import CalendarPage from "@/pages/CalendarPage";
import DocumentLibraryPage, { DocumentTemplateDetailPage } from "@/pages/DocumentLibraryPage";
import InboxPage from "@/pages/InboxPage";
import DisputesPage, { DisputeDetailPage } from "@/pages/DisputesPage";
import ContactsPage from "@/pages/ContactsPage";
import JurisdictionLandingPage from "@/pages/JurisdictionLandingPage";

export default function App() {
  React.useEffect(() => {
    document.title = "Marianne · by Mahakali Tribunal";
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            className:
              "rounded-none border border-[#E8E3F0] bg-white text-[#2A0F5A] font-sans",
          }}
        />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/sign/:token" element={<PublicSignPage />} />
          <Route path="/sign/env/:token" element={<EnvelopeSignPage />} />
          <Route path="/j/:locale" element={<JurisdictionLandingPage />} />
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="matters" element={<MattersListPage />} />
            <Route path="matters/:id" element={<MatterDetailPage />} />
            <Route path="cases" element={<CasesListPage />} />
            <Route path="cases/templates" element={<CaseFilingTemplatesPage />} />
            <Route path="cases/claim-explorer" element={<ClaimExplorerPage />} />
            <Route path="cases/new" element={<NewCasePage />} />
            <Route path="cases/:id" element={<CaseDetailPage />} />
            <Route path="case-starters" element={<CaseStartersPage />} />
            <Route path="case-starters/:slug" element={<CaseStarterWizardPage />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="agreements" element={<AgreementsPage />} />
            <Route path="sign" element={<SignPage />} />
            <Route path="signatures" element={<SignaturesPage />} />
            <Route path="signatures/:id" element={<EnvelopeDetailPage />} />
            <Route path="obligations" element={<ObligationsPage />} />
            <Route path="marketplace" element={<MarketplacePage />} />
            <Route path="agreements/compare" element={<CompareAgreementsPage />} />
            <Route path="disputes" element={<DisputesPage />} />
            <Route path="disputes/:id" element={<DisputeDetailPage />} />
            <Route path="documents" element={<ComingSoonPage variant="documents" />} />
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="inbox" element={<InboxPage />} />
            <Route path="templates" element={<DocumentLibraryPage />} />
            <Route path="templates/:id" element={<DocumentTemplateDetailPage />} />
            <Route path="templates-legacy" element={<TemplatesPage />} />
            <Route path="templates-legacy/:id" element={<TemplateWizardPage />} />
            <Route path="drafts" element={<DraftsListPage />} />
            <Route path="drafts/:id" element={<DraftEditorPage />} />
            <Route path="tasks" element={<TasksPage />} />
            <Route path="education" element={<LearnPage />} />
            <Route path="learn" element={<LearnPage />} />
            <Route path="assistant" element={<AIAssistantPage />} />
            <Route path="nyaya" element={<NyayaDrishtiPage />} />
            <Route path="sentinel" element={<IncidentCapturePage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
